import React from 'react';

import styles from "../../styles/game-center-header-placeholder.module.scss";
import classNames from "classnames";

export const GameCenterHeaderModuleCompetitorPlaceholder = () => {
  return (
    <div className={classNames(styles.competitor)}>
      <div className={classNames(styles.competitor_logo)}/>
      <div className={classNames(styles.competitor_name)}/>
    </div>
  )
};